import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/collection", label: "Collection" },
  { to: "/drives", label: "The Drives" },
  { to: "/memories", label: "Memories" },
  { to: "/videos", label: "Films" },
  { to: "/artwork", label: "Artwork" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-md bg-[color:var(--bg)]/85 border-b border-[color:var(--accent)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-center gap-3"
          aria-label="britcars.us home"
        >
          <span className="inline-block w-7 h-5 relative overflow-hidden border border-[color:var(--accent)]">
            <span className="absolute inset-0 bg-[color:var(--brg)]"></span>
            <span className="absolute inset-0 uj-line"></span>
          </span>
          <span className="font-display text-2xl tracking-tight leading-none">
            britcars<span className="text-[color:var(--oxblood)]">.</span>us
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className={({ isActive }) =>
                `nav-link ${isActive || (n.to !== "/" && pathname.startsWith(n.to)) ? "active" : ""}`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-[color:var(--accent)] bg-[color:var(--bg)]">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                className="nav-link"
                end={n.to === "/"}
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
